(function (){
    'use strict';

    angular
        .module('services')
        .service('TravelExpenseService', TravelExpenseService);

    TravelExpenseService.$inject = ['$http', 'API_BASE'];

    function TravelExpenseService ($http, API_BASE) {
        var service = this;

        service.save                        = save;
        service.update                      = update;
        service.editExpense                 = editExpense;
        service.getExpense                  = getExpense;
        service.deleteTravelExpense         = deleteTravelExpense;
        service.changeAmount                = changeAmount;
        service.approveExpenses             = approveExpenses;
        service.getExpenseForPaymentSeller  = getExpenseForPaymentSeller;
        service.getPendingSharedExpenses    = getPendingSharedExpenses;
        service.approveShareExpense         = approveShareExpense;
        service.disapproveShareExpense      = disapproveShareExpense;
        service.saveComment                 = saveComment;
        service.getAtmSalaryAdvance         = getAtmSalaryAdvance;
        service.saveSalaryAdvance           = saveSalaryAdvance;
        service.approveExpenses             = approveExpenses;
        service.saveStatements              = saveStatements;
        service.getStatements               = getStatements;
        service.getStatement                = getStatement;
        service.getAccounts                 = getAccounts;
        service.updateStatement             = updateStatement;
        service.uploadFile                  = uploadFile;
        service.deleteStatement             = deleteStatement;
        service.setFilters                  = setFilters;
        service.getFilters                  = getFilters;
        service.revertPaymentTravelExpense  = revertPaymentTravelExpense;
        service.getDailyAllowance           = getDailyAllowance;
        service.saveDailyAllowance          = saveDailyAllowance;
        service.deleteDailyAllowance        = deleteDailyAllowance;
        service.updateDailyAllowance        = updateDailyAllowance;

        service.filters;

        function save(query) {
            return $http.post(API_BASE + '/travel-expenses/save', JSON.stringify(query));
        }
        function update(query) {
            return $http.post(API_BASE + '/travel-expenses/update', JSON.stringify(query));
        }
        function editExpense(query) {
            return $http.get(API_BASE + '/travel-expenses/edit', {params:query});
        }
        function getExpense(query) {
            return $http.get(API_BASE + '/travel-expenses/search', {params:query});
        }
        function deleteTravelExpense(query) {
            return $http.get(API_BASE + '/travel-expenses/delete', {params:query});
        }
        function changeAmount(query) {
            return $http.post(API_BASE + '/travel-expenses/change-amount', query);
        }
        function approveExpenses(query) {
            return $http.post(API_BASE + '/travel-expenses/approve', query);
        }

        function getExpenseForPaymentSeller(query) {
            return $http.get(API_BASE + '/travel-expenses/payment-seller', {params:query});
        }    
        function saveStatements(query) {
            return $http.post(API_BASE + '/travel-expenses/save-statements', query);
        }
        function getStatements(query) {
            return $http.get(API_BASE + '/travel-expenses/statements/list', {params: query});
        }
        function getStatement(id) {
            return $http.get(API_BASE + '/travel-expenses/statements/' + id);
        }
        function getAccounts() {
            return $http.get(API_BASE + '/travel-expenses/accounts/');
        }
        function updateStatement(query) {
            return $http.post(API_BASE + '/travel-expenses/statements/update', query);
        }
        function deleteStatement(id) {
            return $http.delete(API_BASE + '/travel-expenses/statements/delete/' + id);
        }
        function uploadFile(file, data) {
            var fd = new FormData();
            fd.append('file', file);
            fd.append('account_id', data.account_id);
            fd.append('adm_user_id', data.adm_user_id);
            return $http.post(API_BASE + '/travel-expenses/uploadStatement', fd, {
               transformRequest: angular.identity,
               headers: {'Content-Type': undefined}
            });
         }
        function getPendingSharedExpenses(id) {
            return $http.get(API_BASE + '/travel-expenses/pending-shared-expenses/' + id);
        }
        function approveShareExpense(share) {
            return $http.post(API_BASE + '/travel-expenses/approve-shared-expense', {share : share});
        }
        function disapproveShareExpense(share) {
            return $http.post(API_BASE + '/travel-expenses/disapprove-shared-expense', {share : share});
        }
        function saveComment(query) {
            return $http.post(API_BASE + '/travel-expenses/save-comment', query);
        }
        function saveSalaryAdvance(query) {
            return $http.post(API_BASE + '/travel-expenses/save-salary-advance', query);
        }
        function getAtmSalaryAdvance(query) {
            return $http.get(API_BASE + '/travel-expenses/get-atm-salary-advance', {params: query});
        }
        function revertPaymentTravelExpense(query) {
            return $http.get(API_BASE + '/travel-expenses/revert-approve', {params: query});
        }
        function setFilters(filters) {
            service.filters = filters;
        }
        function getFilters(filters) {
            return service.filters;
        }

        function getDailyAllowance(query) {
            return $http.get(API_BASE + '/travel-expenses/dailyallowance', {params: query});
        }

        function saveDailyAllowance(query) {
            return $http.post(API_BASE + '/travel-expenses/save-dailyallowance', query);
        }

        function updateDailyAllowance(query) {
            return $http.post(API_BASE + '/travel-expenses/update-dailyallowance', query);
        }

        function deleteDailyAllowance(query) {
            return $http.post(API_BASE + '/travel-expenses/delete-dailyallowance', query);
        }

    }
})();